import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { CSSProperties, Fragment } from 'react';
import { GAME_FIELD_COLUMNS, GAME_FIELD_ROWS, gameModel } from 'entities/game';
import { Lighting } from 'shared/ui';
import { gameFieldModel } from '../../model';
import { GameFieldCell } from '../game-field-cell';
import { GameFieldMultiplier } from '../game-field-multiplier';
import cls from './game-field.module.scss';

type GameFieldProps = {
	className?: string;
};

export const GameField = ({ className }: GameFieldProps) => {
	const [enableOnboarding, disabled, broke] = useUnit([
		gameFieldModel.$enableOnboarding,
		gameFieldModel.fieldDisabledToggler.$active,
		gameModel.$brokeVisible,
	]);

	return (
		<div
			data-disabled={disabled || broke || undefined}
			className={clsx(cls.gameField, className)}
			style={
				{
					'--count-rows': GAME_FIELD_ROWS,
					'--count-columns': GAME_FIELD_COLUMNS + 1,
				} as CSSProperties
			}
			id='game-field'
		>
			<div
				className={cls.gameFieldLeadingCells}
				data-disabled={disabled || undefined}
			>
				{Array(GAME_FIELD_COLUMNS * (GAME_FIELD_ROWS - 1))
					.fill(null)
					.map((_, index) => {
						const reversedIndex = GAME_FIELD_COLUMNS * (GAME_FIELD_ROWS - 1) - 1 - index;
						const columnIndex = index % GAME_FIELD_COLUMNS;
						const rowIndex = Math.floor(reversedIndex / GAME_FIELD_COLUMNS) + 1;

						const cellCorner = [`${GAME_FIELD_ROWS - 1}0`].includes(`${rowIndex}${columnIndex}`);

						const multiplierCorner = [GAME_FIELD_ROWS - 1].includes(rowIndex);

						return (
							<Fragment key={`${rowIndex}${columnIndex}`}>
								<GameFieldCell
									key={`${rowIndex}${columnIndex}`}
									columnIndex={columnIndex}
									rowIndex={rowIndex}
									data-corner={cellCorner || undefined}
								/>
								{columnIndex === GAME_FIELD_COLUMNS - 1 && (
									<GameFieldMultiplier
										key={`multiplier-${rowIndex}`}
										rowIndex={rowIndex}
										data-corner={multiplierCorner || undefined}
									/>
								)}
							</Fragment>
						);
					})}
			</div>
			<div
				className={cls.gameFieldLightingBottomRow}
				data-disabled={(disabled && !enableOnboarding) || undefined}
			>
				<Lighting
					enabled={enableOnboarding}
					className={cls.gameFieldLighting}
				>
					{Array(GAME_FIELD_COLUMNS)
						.fill(null)
						.map((_, index) => {
							const columnIndex = index;
							const rowIndex = 0;

							return (
								<GameFieldCell
									key={`cell-${rowIndex}-${columnIndex}`}
									columnIndex={columnIndex}
									rowIndex={rowIndex}
									data-corner={columnIndex === 0 || undefined}
								/>
							);
						})}
				</Lighting>
				<GameFieldMultiplier
					data-corner
					rowIndex={0}
					className={cls.gameFieldMultiplierBottomRow}
					data-highlight={enableOnboarding || undefined}
				/>
			</div>
		</div>
	);
};
